module.exports = __webpack_public_path__ + "static/media/donation_program_m.c782f637.png";